import { googleClientId } from "config";

const currentOrigin = window.location.origin; // e.g. https://app.client1.com

const centralizedLoginUrl =
  "https://accounts.google.com/o/oauth2/v2/auth?" +
  `client_id=${googleClientId}` +
  `&redirect_uri=${process.env.REACT_APP_SOCIAL_LOGIN}` +
  "&response_type=token" +
  "&scope=openid%20email%20profile" +
  "&prompt=select_account" +
  `&state=${encodeURIComponent(currentOrigin)}`;

export const handleGoogleLogin = () => {
  const popup = window.open(
    centralizedLoginUrl,
    "socialLogin",
    "width=500,height=600"
  );
};
